import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import ActionButton from '../../components/ActionButton/ActionButton';
import PartnerSelectionComponent from './PartnerSelectionComponent';

class PartnerSearchComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openTpaSelectDialog: false,
        };
    }

    setDialogOpen = (value) => {
        this.setState({ openTpaSelectDialog: value });
    };

    handleDialogOpen = () => this.setDialogOpen(true);
    handleDialogClose = () => this.setDialogOpen(false);

    render() {
        const {
            header,
            onPartnerChange,
            dispatch,
            isDisabled,
        } = this.props;
        const { openTpaSelectDialog } = this.state;
        return (
            <Grid container>
                <ActionButton
                    variant="contained"
                    onClick={this.handleDialogOpen}
                    disabled={isDisabled}
                >
                    Fetch Partner
                </ActionButton>
                {
                    openTpaSelectDialog && (
                        <PartnerSelectionComponent
                            header={header}
                            open={openTpaSelectDialog}
                            onClose={this.handleDialogClose}
                            onPartnerChange={onPartnerChange}
                            dispatch={dispatch}
                        />
                    )
                }
            </Grid>
        );
    }
}

PartnerSearchComponent.propTypes = {
    header: PropTypes.string,
    onPartnerChange: PropTypes.func,
    dispatch: PropTypes.func,
    isDisabled: PropTypes.bool,
};

PartnerSearchComponent.defaultProps = {
    header: '',
    onPartnerChange: () => { },
    dispatch: () => {},
    isDisabled: false,
};

export default PartnerSearchComponent;
